import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaConfig, FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
	faCcAmazonPay,
	faCcAmex,
	faCcApplePay,
	faCcDinersClub,
	faCcDiscover,
	faCcJcb,
	faCcMastercard,
	faCcPaypal,
	faCcStripe,
	faCcVisa,
	faLinkedin,
	faSearchengin,
} from '@fortawesome/free-brands-svg-icons';
import { faCircleXmark as fadCircleXmark, faMagnifyingGlassPlus } from '@fortawesome/pro-duotone-svg-icons';
import {
	faChartPieSimple as falChartPieSimple,
	faChartSimple as falChartSimple,
	faFileInvoice as falFileInvoice,
	faFileLines as falFileLines,
	faMessageQuestion as falMessageQuestion,
	faPipe as falPipe,
	faSquare as falSquare,
} from '@fortawesome/pro-light-svg-icons';
import {
	faArrowUpFromBracket as farArrowUpFromBracket,
	faArrowUpToBracket as farArrowUpToBracket,
	faBadgeDollar as farBadgeDollar,
	faBallotCheck as farBallotCheck,
	faBell as farBell,
	faBolt as farBolt,
	faCalendarAlt as farCalendarAlt,
	faCalendarCheck as farCalendarCheck,
	faCalendarLinesPen as farCalendarLinesPen,
	faChampagneGlasses as farChampagneGlasses,
	faChartLineDown as farChartLineDown,
	faChartPieSimpleCircleDollar as farChartPieSimpleCircleDollar,
	faCheckSquare as farCheckSquare,
	faCircle as farCircle,
	faCircleCheck as farCircleCheck,
	faCircleDot as farCircleDot,
	faCircleExclamation as farCircleExclamation,
	faCircleInfo as farCircleInfo,
	faCircleMinus as farCircleMinus,
	faCirclePlay as farCirclePlay,
	faCircleStop as farCircleStop,
	faCircleXmark as farCircleXmark,
	faCity as farCity,
	faClock as farClock,
	faCloudArrowUp as farCloudArrowUp,
	faComments as farComments,
	faCopy as farCopy,
	faEnvelopeCircleCheck as farEnvelopeCircleCheck,
	faExclamationTriangle as farExclamationTriangle,
	faEye as farEye,
	faFileAlt as farFileAlt,
	faFileCertificate as farFileCertificate,
	faFileCirclePlus as farFileCirclePlus,
	faFileCircleQuestion as farFileCircleQuestion,
	faFileContract as farFileContract,
	faFileExcel as farFileExcel,
	faFileLines as farFileLines,
	faFilePdf as farFilePdf,
	faFileSignature as farFileSignature,
	faFireFlame as farFireFlame,
	faFireFlameSimple as farFireFlameSimple,
	faFlag as farFlag,
	faFolderOpen as farFolderOpen,
	faFrown as farFrown,
	faGavel as farGavel,
	faGrinStars as farGrinStars,
	faLightbulb as farLightbulb,
	faLightbulbDollar as farLightbulbDollar,
	faList as farList,
	faListAlt as farListAlt,
	faMagnifyingGlassChart as farMagnifyingGlassChart,
	faMapLocationDot as farMapLocationDot,
	faMeh as farMeh,
	faMoneyBill as farMoneyBill,
	faNotes as farNotes,
	faNoteSticky as farNoteSticky,
	faPlusSquare as farPlusSquare,
	faRefrigerator as farRefrigerator,
	faSensorTriangleExclamation as farSensorTriangleExclamation,
	faSmile as farSmile,
	faSquare as farSquare,
	faSquareList as farSquareList,
	faSquarePlus as farSquarePlus,
	faSquareXmark as farSquareXmark,
	faStar as farStar,
	faTag as farTag,
	faThumbtack as farThumbtack,
	faThumbtackAngle as farThumbtackAngle,
	faTimesCircle as farTimesCircle,
	faTrash as farTrash,
	faUser as farUser,
} from '@fortawesome/pro-regular-svg-icons';
import {
	faAngleRight,
	faAnglesDown,
	faAnglesUp,
	faArchive,
	faArrowDownToBracket,
	faArrowDownToLine,
	faArrowLeft,
	faArrowLeftFromLine,
	faArrowRightArrowLeft,
	faArrowRightLong,
	faArrowsAlt,
	faArrowsFromLine,
	faArrowsRotate,
	faArrowsSpin,
	faArrowsToLine,
	faArrowsUpDownLeftRight,
	faArrowTurnUp,
	faArrowUpFromLine,
	faArrowUpRightFromSquare,
	faArrowUpToLine,
	faBan,
	faBars,
	faBatteryFull,
	faBell,
	faBinaryCircleCheck,
	faBolt,
	faBook,
	faBookmark,
	faBoxDollar,
	faBoxOpen,
	faBuilding,
	faBullhorn,
	faCalendar,
	faCalendarAlt,
	faCalendarCheck,
	faCalendarDays,
	faCalendarLinesPen,
	faCalendarPlus,
	faCalendarRange,
	faCalendarXmark,
	faCaretDown,
	faCaretLeft,
	faCaretRight,
	faCaretSquareRight,
	faCaretUp,
	faChartBar,
	faChartFft,
	faChartKanban,
	faChartLine,
	faChartLineUp,
	faChartPie,
	faChartPieSimpleCircleDollar,
	faChartSimple,
	faChartTreeMap,
	faCheck,
	faCheckCircle,
	faCheckDouble,
	faChevronCircleDown,
	faChevronCircleUp,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCircle,
	faCircleArrowRight,
	faCircleCheck,
	faCircleChevronLeft,
	faCircleDollar,
	faCircleDot,
	faCircleExclamation,
	faCircleInfo,
	faCircleMinus,
	faCircleQuestion,
	faCircleSmall,
	faCircleXmark,
	faClipboard,
	faClipboardCheck,
	faClipboardList,
	faClock,
	faClockRotateLeft,
	faClone,
	faCloudDownloadAlt,
	faCloudSun,
	faCode,
	faCog,
	faCogs,
	faCoins,
	faComment,
	faCommentDollar,
	faComments,
	faCommentsDollar,
	faDatabase,
	faDesktop,
	faDharmachakra,
	faDisplay,
	faDollarSign,
	faDownload,
	faEdit,
	faEllipsisH,
	faEllipsisVertical,
	faEmptySet,
	faEnvelope,
	faEnvelopesBulk,
	faEnvelopeSquare,
	faEquals,
	faExchangeAlt,
	faExclamationCircle,
	faExclamationTriangle,
	faExternalLinkAlt,
	faExternalLinkSquareAlt,
	faEye,
	faEyeSlash,
	faFile,
	faFileAlt,
	faFileCheck,
	faFileCircleXmark,
	faFileContract,
	faFileDownload,
	faFileExcel,
	faFileExclamation,
	faFileExport,
	faFileInvoice,
	faFileInvoiceDollar,
	faFilePlusMinus,
	faFiles,
	faFileSignature,
	faFileSpreadsheet,
	faFileUpload,
	faFilm,
	faFilterCircleXmark,
	faFire,
	faFlag,
	faFlame,
	faFloppyDiskCircleArrowRight,
	faFolderOpen,
	faGavel,
	faGem,
	faGift,
	faGraduationCap,
	faHand,
	faHandHoldingUsd,
	faHeadset,
	faHome,
	faHouse,
	faIdCard,
	faIndustry,
	faInfo,
	faInfoCircle,
	faLaptopMedical,
	faLayerGroup,
	faList,
	faListUl,
	faLock,
	faMagnifyingGlass,
	faMailBulk,
	faMap,
	faMapLocationDot,
	faMedal,
	faMedkit,
	faMessageDollar,
	faMeter,
	faMobileNotch,
	faMobileScreen,
	faMoneyBillWave,
	faNewspaper,
	faNotes,
	faNoteSticky,
	faPaperPlane,
	faPartyHorn,
	faPen,
	faPencil,
	faPencilAlt,
	faPenSquare,
	faPenToSquare,
	faPercent,
	faPercentage,
	faPhone,
	faPhoneAlt,
	faPhoneOffice,
	faPhoneSlash,
	faPhoneVolume,
	faPhotoVideo,
	faPiggyBank,
	faPlay,
	faPlug,
	faPlugCircleBolt,
	faPlugCircleXmark,
	faPlus,
	faPlusCircle,
	faPowerOff,
	faQuestion,
	faQuestionCircle,
	faRankingStar,
	faRedoAlt,
	faReply,
	faRocket,
	faRotateRight,
	faSave,
	faSearch,
	faSearchDollar,
	faServer,
	faShareNodes,
	faShareSquare,
	faSignOutAlt,
	faSlash,
	faSliders,
	faSparkles,
	faSpinner,
	faSquare,
	faSquareArrowDown,
	faSquareArrowUpRight,
	faSquareCheck,
	faSquareInfo,
	faSquarePlus,
	faSquareQuestion,
	faStar,
	faSuitcase,
	faSunCloud,
	faTable,
	faTableCells,
	faTableColumns,
	faTachometerAlt,
	faTag,
	faTasks,
	faThList,
	faThumbsDown,
	faThumbsUp,
	faThumbtack,
	faThumbtackAngle,
	faTimes,
	faTimesCircle,
	faToggleOff,
	faToggleOn,
	faTrash,
	faTrashAlt,
	faTrashUndo,
	faTriangleExclamation,
	faTrophy,
	faUndo,
	faUndoAlt,
	faUpload,
	faUser,
	faUserCheck,
	faUserGroup,
	faUserPen,
	faUsers,
	faUserSecret,
	faUserSlash,
	faUserTie,
	faWavePulse,
	faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import { MaskitoDirective } from '@maskito/angular';
import { EditorModule } from '@tinymce/tinymce-angular';

import { NgJsonEditorModule } from 'ang-jsoneditor';
import {
	DxColorBoxModule,
	DxDataGridModule,
	DxDateBoxModule,
	DxFileUploaderModule,
	DxListModule,
	DxScrollViewModule,
	DxSortableModule,
	DxTagBoxModule,
} from 'devextreme-angular';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TagInputModule } from 'ngx-chips';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxFilesizeModule } from 'ngx-filesize';
import { NgxJsonViewerModule } from 'ngx-json-viewer';

import { ContractCustomizeUserGridConfigModalComponent } from '../contract/modals/contract-customize-user-grid-config/contract-customize-user-grid-config.component';
import { ContractEditUserGridConfigModalComponent } from '../contract/modals/contract-edit-user-grid-config/contract-edit-user-grid-config.component';
import { ContractNewUserGridConfigModalComponent } from '../contract/modals/contract-new-user-grid-config/contract-new-user-grid-config.component';
import { GeneralContractTableComponent } from './components/contract-tables/general-contract-table/general-contract-table.component';
import { FeatureFlagComponent } from './components/feature-flag/feature-flag.component';
import { ActionDropdownComponent } from './components/form/action-dropdown/action-dropdown.component';
import { AgentSelectorComponent } from './components/form/agent-selector/agent-selector.component';
import { ContractSelectorModalComponent } from './components/form/contract-selector/contract-selector-modal/contract-selector-modal.component';
import { ContractSelectorComponent } from './components/form/contract-selector/contract-selector.component';
import { EnterpriseSelectorModalComponent } from './components/form/enterprise-selector/enterprise-selector-modal/enterprise-selector-modal.component';
import { EnterpriseSelectorComponent } from './components/form/enterprise-selector/enterprise-selector.component';
import { FileSelectorComponent } from './components/form/file-selector/file-selector.component';
import { FilterDropdownComponent } from './components/form/filter-dropdown/filter-dropdown.component';
import { FormDropdownComponent } from './components/form/form-dropdown/form-dropdown.component';
import { FormElementComponent } from './components/form/form-element/form-element.component';
import { HtmlEditorComponent } from './components/form/html-editor/html-editor.component';
import { OptionsFilterDropdownComponent } from './components/form/options-filter-dropdown/options-filter-dropdown.component';
import { TypeaheadComponent } from './components/form/typeahead/typeahead.component';
import { UserSelectorComponent } from './components/form/user-selector/user-selector.component';
import { LookupContractComponent } from './components/lookup-contract/lookup-contract.component';
import { MarketRecommendationsComponent } from './components/market-recommendations/market-recommendations.component';
import { PagerComponent } from './components/pager/pager.component';
import { PricingSessionSupplierNotesAddEditComponent } from './components/pricing-session/pricing-session-supplier-notes/pricing-session-supplier-notes-add-edit/pricing-session-supplier-notes-add-edit.component';
import { PricingSessionSupplierNotesViewComponent } from './components/pricing-session/pricing-session-supplier-notes/pricing-session-supplier-notes-view/pricing-session-supplier-notes-view.component';
import { PricingSessionSupplierNotesComponent } from './components/pricing-session/pricing-session-supplier-notes/pricing-session-supplier-notes.component';
import { RateBarComponent } from './components/rate-bar/rate-bar.component';
import { StripeCardElementComponent } from './components/stripe-card-element/stripe-card-element.component';
import { SupplierNoteComponent } from './components/supplier-note/supplier-note.component';
import { TopBannerAlertComponent } from './components/top-banner-alert/top-banner-alert.component';
import { TopLargeBannerAlertComponent } from './components/top-large-banner-alert/top-large-banner-alert.component';
import { VjsPlayerComponent } from './components/vjs-player/vjs-player.component';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation.directive';
import { DblClickDirective } from './directives/dbl-click.directive';
import { LoaderComponent } from './loader/loader.component';
import { AdvisorAcademyTourModalComponent } from './modals/advisor-academy-tour-modal/advisor-academy-tour-modal.component';
import { BrowserDeniedModalComponent } from './modals/browser-denied/browser-denied.component';
import { FeatureTourModalComponent } from './modals/feature-tour-modal/feature-tour-modal.component';
import { GenerateLoaLoeModalComponent } from './modals/generate-loa-loe-modal/generate-loa-loe-modal.component';
import { GeneratePoaModalComponent } from './modals/generate-poa-modal/generate-poa-modal.component';
import { ModalComponent } from './modals/modal.component.abstract';
import { SelectImageModalComponent } from './modals/select-image-modal/select-image-modal.component';
import { TakeoverPopUpModalComponent } from './modals/takeover-pop-up-modal/takeover-pop-up-modal.component';
import { TopBannerAlertLearnMoreModalComponent } from './modals/top-banner-alert-learn-more-modal/top-banner-alert-learn-more-modal.component';
import { WelcomeModalComponent } from './modals/welcome/welcome.component';
import { WINDOW_PROVIdERS } from './models/window-provider';
import { PageWarningsComponent } from './page-warnings/page-warnings.component';
import { AgentCommissionPayableSchedulesPipe } from './pipes/agent-commission-payable-schedules.pipe';
import { AgentCommissionPayablesPipe } from './pipes/agent-commission-payables.pipe';
import { AgentCommissionsPaidReportPipe } from './pipes/agent-commissions-paid-report.pipe';
import { AgentCommissionsPipe } from './pipes/agent-commissions.pipe';
import { AgentsWithLoginsPipe } from './pipes/agents-with-logins.pipe';
import { AuditReportFriendlyDateColumnPipe } from './pipes/audit-report-friendly-date-column.pipe';
import { BillAttachmentsPipe } from './pipes/bill-attachments.pipe';
import { CompensationFilterPipe } from './pipes/compensation-filter.pipe';
import { ConvertBidUnitsPipe } from './pipes/convert-bid-units.pipe';
import { EmailPreferenceSettingTargetDateOptionsFilterPipe } from './pipes/email-preference-setting-target-date-options-filter.pipe';
import { FaqShortAnswerPipe } from './pipes/faq-short-answer.pipe';
import { FilterBestPlansPipe } from './pipes/filter-best-plans.pipe';
import { FilterContractLocationStatusReasonTypesPipe } from './pipes/filter-contract-location-status-reason-types.pipe';
import { FilterControlPipe } from './pipes/filter-control.pipe';
import { FilterEmailCriteriasPipe } from './pipes/filter-email-criterias.pipe';
import { FilterGreenPercentagesPipe } from './pipes/filter-green-percentages.pipe';
import { FilterLoaderGroupsPipe } from './pipes/filter-loader-groups.pipe';
import { FilterLoadersPipe } from './pipes/filter-loaders.pipe';
import { FilterPlanLoadFactorSettingsPipe } from './pipes/filter-plan-load-factor-settings.pipe';
import { FilterPlansPipe } from './pipes/filter-plans.pipe';
import { FilterPricingAnalyticsEffectiveDatesPipe } from './pipes/filter-pricing-analytics-effective-dates.pipe';
import { FilterPricingAnalyticsTermsPipe } from './pipes/filter-pricing-analytics-terms.pipe';
import { FilterPricingAnalyticsUsagesPipe } from './pipes/filter-pricing-analytics-usages.pipe';
import { FilterPricingAnalyticsUtilitiesPipe } from './pipes/filter-pricing-analytics-utilities.pipe';
import { FilterProductsPipe } from './pipes/filter-products.pipe';
import { FilterReportCommissionPaidParentPipe } from './pipes/filter-report-commission-paid-parent.pipe';
import { FilterReportCommissionPaidPipe } from './pipes/filter-report-commission-paid.pipe';
import { FilterStateColumnsPipe } from './pipes/filter-state-columns.pipe';
import { FilterSuppliersPipe } from './pipes/filter-suppliers.pipe';
import { FilterTermsPipe } from './pipes/filter-terms.pipe';
import { FilterUserNotificationsPipe } from './pipes/filter-user-notifications.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { FormatCommissionPayPlanDetailsPipe } from './pipes/format-commission-pay-plan-details.pipe';
import { FormatLicensePlansPipe } from './pipes/format-license-plans.pipe';
import { InternalNotesPipe } from './pipes/internal-notes.pipe';
import { JoinPipe } from './pipes/join.pipe';
import { LicensePlanControlFilterPipe } from './pipes/license-plan-control-filter.pipe';
import { LicensePlanFilterPipe } from './pipes/license-plan-filter.pipe';
import { LicensePlanNameFilterPipe } from './pipes/license-plan-name-filter.pipe';
import { LoadFactorPipe } from './pipes/load-factor.pipe';
import { MarginDisplayPipe } from './pipes/margin-display.pipe';
import { MarketOverviewServiceTypeFilterPipe } from './pipes/market-overview-service-type-filter.pipe';
import { MarketOverviewStateFilterPipe } from './pipes/market-overview-state-filter.pipe';
import { MarketOverviewSupplierFilterPipe } from './pipes/market-overview-supplier-filter.pipe';
import { MarketOverviewUtilityFilterPipe } from './pipes/market-overview-utility-filter.pipe';
import { MarketUpdateAuctionFilterPipe } from './pipes/market-update-auction-filter.pipe';
import { MarketUpdateAuctionServiceTypeFilterPipe } from './pipes/market-update-auction-service-type-filter.pipe';
import { MarketUpdateRateSummaryFilterPipe } from './pipes/market-update-rate-summary-filter.pipe';
import { MarketUpdateRateSummaryServiceTypeFilterPipe } from './pipes/market-update-rate-summary-service-type-filter.pipe';
import { MinusSignToParensPipe } from './pipes/minus-sign-to-parens.pipe';
import { MonthNamePipe } from './pipes/month-name.pipe';
import { NewLinesToBreaksPipe } from './pipes/new-lines-to-breaks.pipe';
import { NumberOrdinalPipe } from './pipes/number-ordinal.pipe';
import { NumberTruncatedPipe } from './pipes/number-truncated.pipe';
import { OrderByControlPipe } from './pipes/order-by-control.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { PendingCommissionViewFilterPipe } from './pipes/pending-commission-view-filter.pipe';
import { PhonePipe } from './pipes/phone.pipe';
import { PriorityPipe } from './pipes/priority.pipe';
import { ProductBidsPipe } from './pipes/product-bids.pipe';
import { RateClassFilterPipe } from './pipes/rate-class-filter.pipe';
import { RfqSettingsFilterPipe } from './pipes/rfq-settings-filter.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SalesTaxPipe } from './pipes/sales-tax.pipe';
import { ServiceTypeUtilitiesPipe } from './pipes/service-type-utilities.pipe';
import { SessionFilterPipe } from './pipes/session-filter.pipe';
import { ShortNumberPipe } from './pipes/short-number.pipe';
import { ShrinkPipe } from './pipes/shrink.pipe';
import { StatesFilterPipe } from './pipes/states-filter.pipe';
import { SupplierBidsPipe } from './pipes/supplier-bids.pipe';
import { TelPipe } from './pipes/tel.pipe';
import { UserNotificationCategoryFilterPipe } from './pipes/user-notification-category-filter.pipe';
import { UtilityFilterPipe } from './pipes/utility-filter.pipe';
import { UtilityServiceTypeMapFilterPipe } from './pipes/utility-service-type-map-filter.pipe';
import { ViewAgentEngagementEventsSortPipe } from './pipes/view-agent-engagement-events-sort.pipe';
import { WarningsFilterPipe } from './pipes/warnings-filter.pipe';
import { ZoneFilterPipe } from './pipes/zone-filter.pipe';

@NgModule({
	declarations: [
		ShrinkPipe,
		FilterPipe,
		OrderByPipe,
		FormatLicensePlansPipe,
		WelcomeModalComponent,
		LoaderComponent,
		ServiceTypeUtilitiesPipe,
		OrderByControlPipe,
		FilterControlPipe,
		PageWarningsComponent,
		MonthNamePipe,
		TelPipe,
		FilterPlansPipe,
		FilterBestPlansPipe,
		SalesTaxPipe,
		LoadFactorPipe,
		ProductBidsPipe,
		SupplierBidsPipe,
		UtilityFilterPipe,
		ZoneFilterPipe,
		PriorityPipe,
		WarningsFilterPipe,
		LicensePlanFilterPipe,
		LicensePlanNameFilterPipe,
		InternalNotesPipe,
		PhonePipe,
		BillAttachmentsPipe,
		JoinPipe,
		MinusSignToParensPipe,
		UtilityServiceTypeMapFilterPipe,
		MarketOverviewStateFilterPipe,
		MarketOverviewServiceTypeFilterPipe,
		MarketOverviewSupplierFilterPipe,
		MarketOverviewUtilityFilterPipe,
		SafeHtmlPipe,
		AgentCommissionsPipe,
		BrowserDeniedModalComponent,
		TakeoverPopUpModalComponent,
		FeatureTourModalComponent,
		MarginDisplayPipe,
		AgentsWithLoginsPipe,
		FilterSuppliersPipe,
		FilterTermsPipe,
		FilterLoadersPipe,
		FilterProductsPipe,
		FilterLoaderGroupsPipe,
		FilterGreenPercentagesPipe,
		ContractCustomizeUserGridConfigModalComponent,
		ContractNewUserGridConfigModalComponent,
		ContractEditUserGridConfigModalComponent,
		FilterStateColumnsPipe,
		LookupContractComponent,
		MarketUpdateRateSummaryFilterPipe,
		MarketUpdateRateSummaryServiceTypeFilterPipe,
		MarketUpdateAuctionFilterPipe,
		MarketUpdateAuctionServiceTypeFilterPipe,
		SessionFilterPipe,
		PagerComponent,
		ConvertBidUnitsPipe,
		UserNotificationCategoryFilterPipe,
		FilterPlanLoadFactorSettingsPipe,
		ActionDropdownComponent,
		AgentSelectorComponent,
		EnterpriseSelectorComponent,
		EnterpriseSelectorModalComponent,
		ContractSelectorComponent,
		ContractSelectorModalComponent,
		UserSelectorComponent,
		FileSelectorComponent,
		FilterDropdownComponent,
		FormDropdownComponent,
		TypeaheadComponent,
		FormElementComponent,
		HtmlEditorComponent,
		AgentCommissionPayableSchedulesPipe,
		SupplierNoteComponent,
		CompensationFilterPipe,
		AuditReportFriendlyDateColumnPipe,
		FilterReportCommissionPaidPipe,
		FaqShortAnswerPipe,
		VjsPlayerComponent,
		FilterReportCommissionPaidParentPipe,
		ClickStopPropagationDirective,
		DblClickDirective,
		StatesFilterPipe,
		RfqSettingsFilterPipe,
		GeneralContractTableComponent,
		RfqSettingsFilterPipe,
		AgentCommissionsPaidReportPipe,
		RateBarComponent,
		LicensePlanNameFilterPipe,
		AgentCommissionPayablesPipe,
		LicensePlanControlFilterPipe,
		FormatCommissionPayPlanDetailsPipe,
		NewLinesToBreaksPipe,
		FilterPricingAnalyticsEffectiveDatesPipe,
		FilterPricingAnalyticsUtilitiesPipe,
		FilterPricingAnalyticsTermsPipe,
		FilterPricingAnalyticsUsagesPipe,
		EmailPreferenceSettingTargetDateOptionsFilterPipe,
		ModalComponent,
		TopBannerAlertComponent,
		TopBannerAlertLearnMoreModalComponent,
		OptionsFilterDropdownComponent,
		FilterContractLocationStatusReasonTypesPipe,
		RateClassFilterPipe,
		NumberOrdinalPipe,
		NumberTruncatedPipe,
		ViewAgentEngagementEventsSortPipe,
		FilterEmailCriteriasPipe,
		GenerateLoaLoeModalComponent,
		GeneratePoaModalComponent,
		DblClickDirective,
		MarketRecommendationsComponent,
		SelectImageModalComponent,
		AdvisorAcademyTourModalComponent,
		TopLargeBannerAlertComponent,
		PendingCommissionViewFilterPipe,
		FilterUserNotificationsPipe,
		StripeCardElementComponent,
		FeatureFlagComponent,
		PricingSessionSupplierNotesComponent,
		PricingSessionSupplierNotesViewComponent,
		PricingSessionSupplierNotesAddEditComponent,
	],
	exports: [
		ShrinkPipe,
		FilterPipe,
		OrderByPipe,
		FormatLicensePlansPipe,
		ServiceTypeUtilitiesPipe,
		OrderByControlPipe,
		FilterControlPipe,
		WelcomeModalComponent,
		LoaderComponent,
		FormsModule,
		ReactiveFormsModule,
		NgxFilesizeModule,
		DxDataGridModule,
		DxDateBoxModule,
		DxFileUploaderModule,
		DxListModule,
		DxSortableModule,
		DxScrollViewModule,
		DxColorBoxModule,
		DxTagBoxModule,
		PageWarningsComponent,
		MonthNamePipe,
		TelPipe,
		FilterPlansPipe,
		FilterBestPlansPipe,
		SalesTaxPipe,
		LoadFactorPipe,
		ProductBidsPipe,
		SupplierBidsPipe,
		UtilityFilterPipe,
		ZoneFilterPipe,
		RateClassFilterPipe,
		PriorityPipe,
		WarningsFilterPipe,
		LicensePlanFilterPipe,
		LicensePlanNameFilterPipe,
		InternalNotesPipe,
		PhonePipe,
		NgxExtendedPdfViewerModule,
		BillAttachmentsPipe,
		NgxJsonViewerModule,
		JoinPipe,
		MinusSignToParensPipe,
		UtilityServiceTypeMapFilterPipe,
		MarketOverviewStateFilterPipe,
		MarketOverviewServiceTypeFilterPipe,
		MarketOverviewSupplierFilterPipe,
		MarketOverviewUtilityFilterPipe,
		SafeHtmlPipe,
		AgentCommissionsPipe,
		TakeoverPopUpModalComponent,
		FeatureTourModalComponent,
		AgentCommissionPayableSchedulesPipe,
		AgentCommissionsPaidReportPipe,
		NgJsonEditorModule,
		MarginDisplayPipe,
		AgentsWithLoginsPipe,
		FilterSuppliersPipe,
		FilterTermsPipe,
		FilterLoadersPipe,
		FilterProductsPipe,
		FilterLoaderGroupsPipe,
		FilterGreenPercentagesPipe,
		FontAwesomeModule,
		ModalModule,
		CollapseModule,
		BsDropdownModule,
		BsDatepickerModule,
		CarouselModule,
		TabsModule,
		TooltipModule,
		PopoverModule,
		ButtonsModule,
		ProgressbarModule,
		AccordionModule,
		LookupContractComponent,
		MarketUpdateRateSummaryFilterPipe,
		MarketUpdateRateSummaryServiceTypeFilterPipe,
		MarketUpdateAuctionFilterPipe,
		MarketUpdateAuctionServiceTypeFilterPipe,
		SessionFilterPipe,
		PagerComponent,
		ConvertBidUnitsPipe,
		UserNotificationCategoryFilterPipe,
		FilterPlanLoadFactorSettingsPipe,
		TypeaheadModule,
		ActionDropdownComponent,
		AgentSelectorComponent,
		EnterpriseSelectorComponent,
		EnterpriseSelectorModalComponent,
		ContractSelectorComponent,
		UserSelectorComponent,
		FileSelectorComponent,
		FilterDropdownComponent,
		OptionsFilterDropdownComponent,
		FormDropdownComponent,
		TypeaheadComponent,
		FormElementComponent,
		HtmlEditorComponent,
		SupplierNoteComponent,
		CompensationFilterPipe,
		AuditReportFriendlyDateColumnPipe,
		FilterReportCommissionPaidPipe,
		TagInputModule,
		AuditReportFriendlyDateColumnPipe,
		FaqShortAnswerPipe,
		VjsPlayerComponent,
		FilterReportCommissionPaidParentPipe,
		ClickStopPropagationDirective,
		DblClickDirective,
		StatesFilterPipe,
		GeneralContractTableComponent,
		RfqSettingsFilterPipe,
		RateBarComponent,
		AgentCommissionPayableSchedulesPipe,
		AgentCommissionPayablesPipe,
		LicensePlanControlFilterPipe,
		FormatCommissionPayPlanDetailsPipe,
		NewLinesToBreaksPipe,
		FilterPricingAnalyticsEffectiveDatesPipe,
		FilterPricingAnalyticsUtilitiesPipe,
		FilterPricingAnalyticsTermsPipe,
		FilterPricingAnalyticsUsagesPipe,
		EmailPreferenceSettingTargetDateOptionsFilterPipe,
		ModalComponent,
		TopBannerAlertComponent,
		TopBannerAlertLearnMoreModalComponent,
		FilterContractLocationStatusReasonTypesPipe,
		NumberOrdinalPipe,
		NumberTruncatedPipe,
		ViewAgentEngagementEventsSortPipe,
		FilterEmailCriteriasPipe,
		GenerateLoaLoeModalComponent,
		GeneratePoaModalComponent,
		MarketRecommendationsComponent,
		MaskitoDirective,
		TopLargeBannerAlertComponent,
		PendingCommissionViewFilterPipe,
		FilterUserNotificationsPipe,
		StripeCardElementComponent,
		FeatureFlagComponent,
		PricingSessionSupplierNotesComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		NgxFilesizeModule,
		DxDataGridModule,
		DxFileUploaderModule,
		DxDateBoxModule,
		DxListModule,
		DxSortableModule,
		DxScrollViewModule,
		DxColorBoxModule,
		DxTagBoxModule,
		EditorModule,
		NgxExtendedPdfViewerModule,
		NgxJsonViewerModule,
		NgJsonEditorModule,
		FontAwesomeModule,
		TagInputModule,
		ModalModule.forRoot(),
		CollapseModule.forRoot(),
		BsDropdownModule.forRoot(),
		BsDatepickerModule.forRoot(),
		CarouselModule.forRoot(),
		TabsModule.forRoot(),
		TooltipModule.forRoot(),
		PopoverModule.forRoot(),
		ProgressbarModule.forRoot(),
		AccordionModule.forRoot(),
		TypeaheadModule.forRoot(),
		ButtonsModule.forRoot(),
		MaskitoDirective,
	],
	providers: [
		WINDOW_PROVIdERS,
		FilterPlansPipe,
		FilterBestPlansPipe,
		CurrencyPipe,
		ShortNumberPipe,
		OrderByPipe,
		DatePipe,
		DecimalPipe,
		OrderByControlPipe,
		MinusSignToParensPipe,
		ZoneFilterPipe,
		RateClassFilterPipe,
		AgentCommissionsPipe,
		AgentCommissionsPaidReportPipe,
		ShrinkPipe,
		StatesFilterPipe,
		UtilityFilterPipe,
		UserNotificationCategoryFilterPipe,
		CompensationFilterPipe,
		LoadFactorPipe,
		FilterReportCommissionPaidPipe,
		ServiceTypeUtilitiesPipe,
		AgentCommissionPayableSchedulesPipe,
		PhonePipe,
		NumberOrdinalPipe,
		NumberTruncatedPipe,
		ViewAgentEngagementEventsSortPipe,
		ConvertBidUnitsPipe,
		PendingCommissionViewFilterPipe,
		LicensePlanControlFilterPipe,
		LicensePlanFilterPipe,
		provideHttpClient(withInterceptorsFromDi()),
	],
})
export class SharedModule {
	constructor(library: FaIconLibrary, faConfig: FaConfig) {
		faConfig.fallbackIcon = faCircleQuestion;
		library.addIcons(
			faFire,
			faBolt,
			faQuestion,
			faSignOutAlt,
			faExchangeAlt,
			faSearchDollar,
			faArrowsRotate,
			faSearch,
			faBars,
			faWavePulse,
			faTimes,
			faBookmark,
			faBook,
			faRocket,
			faBell,
			farBell,
			faBinaryCircleCheck,
			faExclamationTriangle,
			faTriangleExclamation,
			faCircleArrowRight,
			faCog,
			faCogs,
			faSparkles,
			faSpinner,
			faLaptopMedical,
			faQuestionCircle,
			faPhotoVideo,
			faPencilAlt,
			faChevronRight,
			faChevronDown,
			faChevronLeft,
			faChevronUp,
			faCheck,
			faUserSecret,
			faPlus,
			faEdit,
			faChevronCircleDown,
			faChevronCircleUp,
			farFireFlameSimple,
			faTrash,
			faTrashAlt,
			faCloudDownloadAlt,
			faChartBar,
			faChartTreeMap,
			faEye,
			faEyeSlash,
			faCoins,
			faMap,
			faLock,
			faCommentDollar,
			faFileInvoiceDollar,
			faTasks,
			faPaperPlane,
			faCheckCircle,
			faMedal,
			faGem,
			faInfoCircle,
			faEnvelope,
			faPlusCircle,
			faUpload,
			faFileAlt,
			faArrowRightLong,
			faArrowRightArrowLeft,
			faCircle,
			faCircleInfo,
			faCircleExclamation,
			farCircleExclamation,
			faGavel,
			faFile,
			faMapLocationDot,
			farMapLocationDot,
			faFlag,
			farFlag,
			faSquare,
			farSquare,
			faSquarePlus,
			farSquarePlus,
			faSquareCheck,
			faMailBulk,
			faTable,
			faSave,
			faStar,
			faUser,
			faDisplay,
			faDownload,
			faPhone,
			faFilterCircleXmark,
			faDollarSign,
			faHome,
			faPencilAlt,
			faMedkit,
			faTachometerAlt,
			faChartLine,
			faChartLineUp,
			faExchangeAlt,
			faTimesCircle,
			faPowerOff,
			farCheckSquare,
			faExternalLinkAlt,
			faExternalLinkSquareAlt,
			faShareSquare,
			faShareNodes,
			faNewspaper,
			faNoteSticky,
			faChartPie,
			faAngleRight,
			faComment,
			faDharmachakra,
			faCircleSmall,
			faSquareArrowUpRight,
			faPlay,
			faBan,
			faUndo,
			faCalendar,
			faCalendarAlt,
			faCalendarDays,
			faEllipsisH,
			faEllipsisVertical,
			faCaretRight,
			faCaretLeft,
			faCaretSquareRight,
			faFileInvoice,
			faExclamationCircle,
			faArchive,
			faBullhorn,
			farSmile,
			farFrown,
			farLightbulb,
			farLightbulbDollar,
			farTimesCircle,
			faUserTie,
			faCommentsDollar,
			faChartFft,
			faTag,
			faArrowLeft,
			faFileDownload,
			faFileSpreadsheet,
			farCircleInfo,
			faPhoneAlt,
			faClock,
			faList,
			faCaretDown,
			faCaretUp,
			faClone,
			faHandHoldingUsd,
			faPhoneVolume,
			farFilePdf,
			faRedoAlt,
			faReply,
			faPercentage,
			faExternalLinkAlt,
			faDharmachakra,
			faCircleSmall,
			faSquareArrowUpRight,
			faPlay,
			faPercent,
			faUndoAlt,
			faFileContract,
			faBoxOpen,
			faPlug,
			faMoneyBillWave,
			faPenSquare,
			faFilm,
			faFolderOpen,
			farFolderOpen,
			farFileAlt,
			farMeh,
			farComments,
			farGrinStars,
			faListUl,
			faUserCheck,
			faRankingStar,
			farPlusSquare,
			faPen,
			faComments,
			farCalendarAlt,
			faFileUpload,
			faUserSlash,
			faUsers,
			faSlash,
			faEnvelopeSquare,
			faArrowsAlt,
			faCircleChevronLeft,
			faClipboardList,
			faFileExport,
			faThList,
			farListAlt,
			faFileExcel,
			faPhoneSlash,
			faExclamationCircle,
			farCirclePlay,
			farCircleStop,
			faCircleCheck,
			faFileCircleXmark,
			faCircleXmark,
			faCircleMinus,
			faSliders,
			faArrowsUpDownLeftRight,
			faRotateRight,
			faInfo,
			faXmark,
			faAnglesDown,
			faAnglesUp,
			faToggleOn,
			faToggleOff,
			faFlag,
			farNoteSticky,
			faSquareInfo,
			farCircleCheck,
			farCircleMinus,
			farCircleXmark,
			farBallotCheck,
			fadCircleXmark,
			faMagnifyingGlass,
			faPlugCircleXmark,
			faFileCheck,
			faFloppyDiskCircleArrowRight,
			faArrowUpToLine,
			faArrowDownToLine,
			farSquareXmark,
			farMoneyBill,
			faCalendarLinesPen,
			farCalendarLinesPen,
			farNotes,
			faGift,
			faSuitcase,
			faArrowLeftFromLine,
			falMessageQuestion,
			farFileCertificate,
			farBadgeDollar,
			faPiggyBank,
			faHeadset,
			farFileSignature,
			faPartyHorn,
			faUserGroup,
			faArrowsSpin,
			faNotes,
			farChampagneGlasses,
			faClockRotateLeft,
			faChartKanban,
			farRefrigerator,
			faMobileScreen,
			faPhoneOffice,
			farList,
			farClock,
			faEnvelopesBulk,
			faCheckDouble,
			falPipe,
			faFileExclamation,
			faLayerGroup,
			faEmptySet,
			faMessageDollar,
			faChartPieSimpleCircleDollar,
			faArrowUpFromLine,
			farChartPieSimpleCircleDollar,
			farCalendarCheck,
			faThumbsDown,
			faPlugCircleBolt,
			farCity,
			farChartLineDown,
			faDesktop,
			faMobileNotch,
			faCloudSun,
			faSunCloud,
			faLinkedin,
			faCcAmazonPay,
			faCcAmex,
			faCcApplePay,
			faCcDinersClub,
			faCcDiscover,
			faCcJcb,
			faCcMastercard,
			faCcPaypal,
			faCcStripe,
			faCcVisa,
			faPenToSquare,
			falFileInvoice,
			farFileCircleQuestion,
			farBolt,
			farEnvelopeCircleCheck,
			farSensorTriangleExclamation,
			faArrowUpRightFromSquare,
			farCopy,
			faTrashUndo,
			faGraduationCap,
			faArrowDownToBracket,
			faThumbtack,
			faDatabase,
			faMeter,
			faHouse,
			faCircleDollar,
			faClipboard,
			faClipboardCheck,
			faCircleQuestion,
			farThumbtack,
			faTableCells,
			faUpload,
			faEquals,
			farCloudArrowUp,
			faServer,
			faFilePlusMinus,
			faCalendarRange,
			faArrowTurnUp,
			faCalendarPlus,
			farMagnifyingGlassChart,
			faCalendarXmark,
			faCalendarCheck,
			faFiles,
			faThumbsUp,
			faTrophy,
			faChartSimple,
			faSquareArrowDown,
			faSquareArrowUpRight,
			faIndustry,
			faArrowsFromLine,
			faArrowsToLine,
			faSquareQuestion,
			faFlame,
			faSparkles,
			faThumbtackAngle,
			faDharmachakra,
			faCircleSmall,
			farThumbtackAngle,
			farArrowUpFromBracket,
			farArrowUpToBracket,
			farArrowUpFromBracket,
			farArrowUpToBracket,
			farTag,
			farGavel,
			farUser,
			faArrowLeft,
			faChartFft,
			faTag,
			farTrash,
			faMagnifyingGlassPlus,
			faSearchengin,
			faBoxDollar,
			faIdCard,
			farFireFlame,
			farBolt,
			faBuilding,
			faUserPen,
			farBolt,
			farFireFlame,
			farFileCirclePlus,
			faFileSignature,
			faHand,
			farFileLines,
			farSquareList,
			farFileContract,
			farEye,
			farFileExcel,
			faCode,
			faBatteryFull,
			farCircle,
			farCircleDot,
			faCircleDot,
			falChartPieSimple,
			falChartSimple,
			falFileLines,
			falSquare,
			faPencil,
			farStar,
			faTableColumns,
			faCircleDot,
			farExclamationTriangle,
		);
	}
}
